import React from 'react'
import classes from './ResultsSection.module.css'
const ResultsSection = ({
  title,
  subtitle,
  results,
  names,
  rows,
  withPercent = false,
  breakLastItem = false,
  layoutPattern,
  allowNegative = false,
}) => {
  const safeResults = Array.isArray(results) ? results : []

  const formatResult = (result) => {
    if (Number.isFinite(Number(result))) {
      let value = result

      if (!allowNegative) {
        value = Math.max(0, value)
      }

      if (withPercent) {
        value = Math.min(value, 100)
      }

      return value
    } else if (typeof result === 'string' && result.includes(':')) {
      return result.replace(/:/g, ' : ')
    } else if (typeof result === 'string') {
      return result
    } else {
      return 'N/A'
    }
  }

  const parseLayoutPattern = (pattern, totalItems) => {
    if (!pattern) return [[...Array(totalItems).keys()]]

    const layout = []
    let index = 0
    let repeatStart = 0
    let repeatTokens = []

    const tokens = pattern.trim().split('')
    let currentRow = []

    const processToken = (token) => {
      if (token === '.') {
        if (index < totalItems) {
          currentRow.push(index++)
        }
      } else if (token === '-') {
        if (currentRow.length) {
          layout.push(currentRow)
          currentRow = []
        }
      } else if (token === ' ') {
        if (currentRow.length) {
          layout.push(currentRow)
          currentRow = []
        }
        layout.push('gap')
      }
    }

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i]

      if (token === '+') {
        repeatTokens = tokens.slice(repeatStart, i)
        break
      }

      processToken(token)
    }

    if (currentRow.length) {
      layout.push(currentRow)
      currentRow = []
    }

    // repeat if '+' present and has more items
    while (index < totalItems && repeatTokens.length > 0) {
      for (const token of repeatTokens) {
        processToken(token)
        if (index >= totalItems) break
      }

      if (currentRow.length) {
        layout.push(currentRow)
        currentRow = []
      }
    }

    return layout
  }

  const layout = layoutPattern
    ? parseLayoutPattern(layoutPattern, safeResults.length)
    : null

  return (
    <div className={classes.sectionContainer}>
      {title && <div className={classes.sectionTitle}>{title}</div>}

      <div className={classes.oddsResultContainer}>
        {subtitle && <span className={classes.calcButton}>{subtitle}</span>}

        {!layoutPattern && (
          <div
            className={`${classes.oddsResult} ${
              rows === 2
                ? classes.multiRowTwo
                : rows === 3
                ? classes.multiRowThree
                : rows === 4
                ? classes.multiRowFour
                : rows === 5
                ? classes.multiRowFive
                : rows > 1
                ? classes.multiRow
                : ''
            }`}
          >
            {safeResults.map((result, index) => (
              <div
                key={index}
                className={`${classes.resultItem} ${
                  breakLastItem && index === 2 ? classes.breakLastItem : ''
                }`}
              >
                <span className={classes.resultHeader}>{names[index]}</span>
                <span>
                  {formatResult(result)}
                  {withPercent && isFinite(result) ? ' %' : ''}
                </span>
              </div>
            ))}
          </div>
        )}

        {layoutPattern && (
          <div className={classes.oddsResult}>
            {layout.map((item, rowIndex) => {
              if (item === 'gap') {
                return (
                  <div key={`gap-${rowIndex}`} className={classes.gapRow} />
                )
              }

              return (
                <div key={`row-${rowIndex}`} className={classes.resultRow}>
                  {item.map((itemIndex) => (
                    <div key={itemIndex} className={classes.resultItem}>
                      <span className={classes.resultHeader}>
                        {names[itemIndex]}
                      </span>
                      <span>
                        {formatResult(safeResults[itemIndex])}
                        {withPercent && isFinite(safeResults[itemIndex])
                          ? ' %'
                          : ''}
                      </span>
                    </div>
                  ))}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ResultsSection
